import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PiCoinsDuotone } from "react-icons/pi";
import { AiOutlineClose } from "react-icons/ai";
import { CiMenuBurger } from "react-icons/ci";
import Button from "./Button";
const NavItem = ({ children, href, onClick }) => {
  const handleClick = () => {
    onClick();
  };

  return (
    <li className="relative w-full">
      <a href={href} onClick={handleClick}>
        <p className="py-3 md:py-0 duration-300 ease-linear hover:translate-y-[-4px] hover:translate-x-[-4px] font-medium text-slate-800">
          {children}
        </p>
      </a>
    </li>
  );
};

const Header = () => {
  const [menu, setMenu] = useState(false);
  const closeMenu = () => {
    setMenu(false);
  };

  return (
    <div
      className={
        menu
          ? "container mt-8"
          : "container items-center justify-between mt-8 md:flex"
      }
    >
      {/* Logo */}
      <div className="flex justify-between space-x-2">
        <div className="flex space-x-2 ">
          <PiCoinsDuotone className="w-7 h-7" />
          <Link
            to={"/"}
            className="text-xl italic font-medium cursor-pointer text-slate-900"
          >
            CoinWatch
          </Link>
        </div>
        {/* Menu Toggle */}
        <div className="flex md:flex-none md:space-x-0">
          {menu ? (
            <AiOutlineClose
              onClick={() => setMenu(!menu)}
              className="block w-5 h-5 md:hidden"
            />
          ) : (
            <CiMenuBurger
              onClick={() => setMenu(!menu)}
              className="block w-5 h-5 md:hidden"
            />
          )}
        </div>
      </div>
      <div className={`md:flex md:justify-center ${menu ? "flex" : "hidden"}`}>
        <ul className="cursor-pointer md:space-x-5 md:flex text-slate-900">
          <NavItem onClick={closeMenu}>
            <Link to={"/"}>home</Link>
          </NavItem>
          <NavItem onClick={closeMenu}>
            <Link to={"/Cryptocurrencies"}>cryptocurrencies</Link>
          </NavItem>
          <NavItem onClick={closeMenu}>
            <Link to={"/Bookmarked"}>bookmarked</Link>
          </NavItem>
        </ul>
      </div>
      <div className={`md:flex md:justify-center ${menu ? "flex" : "hidden"}`}>
        <Button to={`/Cryptocurrencies`}>Get Started</Button>
      </div>
    </div>
  );
};

export default Header;
